import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Plans from './pages/Plans';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Terms from './pages/Terms';
import ComplaintsBook from './pages/ComplaintsBook';
import FAQ from './pages/FAQ';
import Agencies from './pages/Agencies';
import AgencyDetails from './pages/AgencyDetails';
import ErrorPage from './pages/ErrorPage';
import ProfessionalForm from './pages/Register/ProfessionalForm';
import EmpreendimentoForm from './pages/Register/EmpreendimentoForm';
import Property from './pages/Property';
import Login from './pages/Login';
import Success from './pages/Success';
import UserLogin from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import SearchResults from './pages/SearchResults';
import Category from './pages/Category';
import NewProperty from './pages/NewProperty';
import ComparePage from './pages/Compare';
import FavoritesPage from './pages/Favorites';
import HighlightsPage from './pages/Highlights';
import Profile from './pages/Dashboard/Profile';
import Messages from './pages/Dashboard/Messages';
import Atendimento from './pages/Dashboard/Atendimento';
import ContatoListagem from './pages/Dashboard/Contato/index';
import NewsletterDashboard from './pages/Dashboard/Newsletter';
import Reservations from './pages/Dashboard/Reservations';
import ReservationDetail from './pages/Dashboard/Reservations/ReservationDetail';
import Invoices from './pages/Dashboard/Invoices';
import Favorites from './pages/Dashboard/Favorites';
import Listings from './pages/Dashboard/Listings';
import AllListings from './pages/Dashboard/AllListings';
import NewListing from './pages/Dashboard/NewListing';
import EditListing from './pages/Dashboard/EditListing';
import Payments from './pages/Dashboard/Payments';
import MyPackages from './pages/Dashboard/MyPackage';
const MyHighlights = React.lazy(() => import('./pages/Dashboard/MyHighlights'));
import Agency from './pages/Dashboard/Agency';
import EditAgency from './pages/Dashboard/EditAgency';
import NewAgency from './pages/Dashboard/NewAgency';
import Agents from './pages/Dashboard/Agents';
import Categorias from './pages/Dashboard/Categorias';
import TiposImovel from './pages/Dashboard/TiposImovel';
import Paises from './pages/Dashboard/Paises';
import FaqTipos from './pages/Dashboard/FaqTipos';
import Faqs from './pages/Dashboard/Faqs';
import Newsletter from './pages/Dashboard/Newsletter';
import ContactMediation from './pages/Dashboard/ContactMediation';
import CRMLeads from './pages/Dashboard/CRMLeads';
import ValidateAccount from './pages/ValidateAccount';
import Planos from './pages/Dashboard/Planos';
import TiposPlanos from './pages/Dashboard/TiposPlanos';
import PaginaTeste from './pages/Dashboard/PaginaTeste';
import Idiomas from './pages/Dashboard/Idiomas';
import CadastroHostd from './pages/CadastroHostd';
import FiscalTaxRules from './pages/Dashboard/FiscalTaxRules';
import PromotionManager from './pages/Dashboard/PromotionManager';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: 'about',
        element: <About />
      },
      {
        path: 'contact',
        element: <Contact />
      },
      {
        path: 'contato',
        element: <Contact />
      },
      {
        path: 'plans',
        element: <Plans />
      },
      {
        path: '/cadastro/hostd',
        element: <CadastroHostd />,
        errorElement: <ErrorPage />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />
      },
      {
        path: 'terms',
        element: <Terms />
      },
      {
        path: '/category/:category',
        element: <Category />
      },
      {
        path: '/category/:category/:slug',
        element: <Category />
      },
      {
        path: 'search-results',
        element: <SearchResults />
      },
      {
        path: 'destaques',
        element: <HighlightsPage />
      },
      {
        path: 'compare',
        element: <ComparePage />,
        errorElement: <ErrorPage />
      },
      {
        path: 'favorites',
        element: <FavoritesPage />,
        errorElement: <ErrorPage />
      },
      {
        path: 'cookie-policy',
        element: <CookiePolicy />
      },
      {
        path: 'complaints-book',
        element: <ComplaintsBook />
      },
      {
        path: 'faq',
        element: <FAQ />
      },
      {
        path: 'agencies',
        element: <Agencies />
      },
      {
        path: 'agencies/:id',
        element: <AgencyDetails />
      },
      {
        path: '/property/:id',
        element: <Property />,
        errorElement: <ErrorPage />
      },
      {
        path: '/property/:id/:slug',
        element: <Property />,
        errorElement: <ErrorPage />
      },
      {
        path: '/login',
        element:  <Login />,
        errorElement: <ErrorPage />
      },
      {
        path: '/register/professional',
        element: <ProfessionalForm />, 
        errorElement: <ErrorPage />
      },
      {
        path: '/register/empreendimento',
        element: <EmpreendimentoForm />, 
        errorElement: <ErrorPage />
      },
      {
        path: '/register',
        element: <Register />, 
        errorElement: <ErrorPage />
      },
      {
        path: '/register/professional',
        element: <ProfessionalForm />,
        errorElement: <ErrorPage />
      },
      {
        path: '/register/empreendimento',
        element: <EmpreendimentoForm />,
        errorElement: <ErrorPage />
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />,
        errorElement: <ErrorPage />
      },
      {
        path: '/reset-de-senha/:token',
        element: <ResetPassword />,
        errorElement: <ErrorPage />
      },
      {
        path: '/new-property',
        element: <NewProperty />,
        errorElement: <ErrorPage />
      },
      {
        path: '/validar/:token',
        element: <ValidateAccount />,
        errorElement: <ErrorPage />
      },
    ]
  },
  
  // Rota do Dashboard com layout próprio
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'profile',
        element: <Profile />
      },
      {
        path: 'agents',
        element: <Agents />
      },
      {
        path: 'agency',
        element: <Agency />
      },
      {
        path: 'edit-agency/:id',
        element: <EditAgency />
      },
      {
        path: 'new-agency',
        element: <NewAgency />
      },
      {
        path: 'messages',
        element: <Messages />
      },
      {
        path: 'contato',
        element: <ContatoListagem />
      },
      {
        path: 'contatos',
        element: <Messages />
      },
      {
        path: 'newsletter',
        element: <NewsletterDashboard />
      },
      {
        path: 'reservations',
        element: <Reservations />
      },
      {
        path: 'reservations/:id',
        element: <ReservationDetail />
      },
      {
        path: 'invoices',
        element: <Invoices />
      },
      {
        path: 'payments',
        element: <Payments />
      },
      {
        path: 'listings',
        element: <Listings />
      },
      {
        path: 'all-listings',
        element: <AllListings />
      },
      {
        path: 'packages',
        element: <MyPackages />
      },
      {
        path: 'highlights',
        element: <MyHighlights />
      },
      {
        path: 'favorites',
        element: <Favorites />
      },
      {
        path: 'newlisting',
        element: <NewListing />
      },
      {
        path: 'edit-listing/:id',
        element: <EditListing />
      }, 
      {
        path: 'categorias',
        element: <Categorias />,
      },
      {
        path: 'tiposimovel',
        element: <TiposImovel />,
      },
      {
        path: 'pais',
        element: <Paises />,
      },
      {
        path: 'regras-fiscais',
        element: <ProtectedRoute requiredRole="ADMIN"><FiscalTaxRules /></ProtectedRoute>,
      },
      {
        path: 'promocoes',
        element: <ProtectedRoute requiredRole="ADMIN"><PromotionManager /></ProtectedRoute>,
      },
      {
        path: 'faqtipos',
        element: <FaqTipos />,
      },
      {
        path: 'faq',
        element: <Faqs />,
      },
      {
        path: 'newsletter',
        element: <Newsletter />,
      },
      {
        path: 'planos',
        element: <Planos />,
      },
      {
        path: 'tipos-planos',
        element: <TiposPlanos />, 
      },
      {
        path: 'contact-mediation',
        element: <ContactMediation />, 
      },
      {
        path: 'atendimento',
        element: <ProtectedRoute requiredRole="ADMIN"><Atendimento /></ProtectedRoute>,
      },
      {
        path: 'crm-leads',
        element: <CRMLeads />,
      },
      {
        path: 'dominios',
        element: <PaginaTeste />,
      },
      {
        path: 'pagina-teste',
        element: <Navigate to="/dashboard/dominios" replace />,
      }, 
      {
        path: 'idiomas',
        element: <Idiomas />,
      },
    ]
  },
 
  {
    path: '/success',
    element: <Success />,
    errorElement: <ErrorBoundary />
  },
  {
    path: '*',
    element: <ErrorPage />
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});
